<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="事务执行管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
           <el-form-item label="事务标题">
            <el-input v-model="params.InfoTitle" placeholder="请输入事务标题" clearable />
          </el-form-item>
            <el-form-item label="提交商家">
            <el-input v-model="params.SubmitEnterprise" placeholder="请输入提交商家" clearable />
          </el-form-item>
          
          <el-form-item label="处理状态">
            <el-select v-model="params.State" placeholder="请选择处理状态" clearable>
             
              <el-option label="未处理" :value="0"></el-option>
              <el-option label="处理中" :value="1"></el-option>
              <el-option label="已完成" :value="2"></el-option>
           
            </el-select>
          </el-form-item>
         
          <el-form-item label="提交时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.SubmitStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.SubmitEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>
          

           
        </template>
        <template slot="table">
          <el-table-column prop="InfoTitle" label="事务标题"  />
          <el-table-column prop="SubmitEnterprise" label="提交商家"   />
         
          <el-table-column prop="SubmitTime" label="提交时间" />

          
          <el-table-column prop="State" align="center" label="处理状态" width="80">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info" v-if="row.State==0">未处理</el-tag>
            <el-tag size="small" type="primary" v-else-if="row.State==1">处理中</el-tag>
         
         
          </template>
        </el-table-column>
       
          
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
         InfoTitle: "",
         InfoType: "",
         SubmitEnterprise: "",
         SubmitStarttime: null,
         SubmitEndtime: null,
         
        }, 
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{InfoTitle:"测试事项一",SubmitEnterprise:"达信",SubmitTime:"2024-04-13 10:01:12",State:0},{InfoTitle:"测试事项二",SubmitEnterprise:"测试商家",SubmitTime:"2024-02-13 10:01:12",State:1}]});
      })
    },
     
    },
  };
  </script>